import { Avatar, Text } from "@/elements"
import { MessagesAvatar } from "./MessagesAvatar"

const ChannelPreviewSkeleton: React.FC = () => {
  return (
    <div className="flex h-[86px] w-full flex-row items-center">
      <div className="pr-4">
        <MessagesAvatar src="" alt="" />
      </div>
      <div className="flex w-full flex-row justify-between">
        <div>
          <div className="h-[18px] w-[100px] animate-pulse bg-bg-2" />
          <div className="mt-1 h-[18px] w-[80px] animate-pulse bg-bg-2" />
        </div>
        <div className="h-[18px] w-[70px] animate-pulse bg-bg-2" />
      </div>
    </div>
  )
}

export const MessagesSkeleton: React.FC = () => {
  return (
    <>
      <div className="relative order-2 flex w-screen flex-shrink-0 overflow-hidden bg-bg-1 sm:w-[420px]">
        <div className="h-full w-full border-r border-bg-2">
          <div className="flex h-[90px] flex-row items-center justify-between border-b border-bg-3 px-6">
            <Text variant="h5">Messages</Text>
            <div className="size-[30px] animate-pulse rounded-[2px] bg-bg-2" />
          </div>
          <div className="px-6">
            <div className="mt-4 flex h-[40px] flex-1 animate-pulse rounded-full bg-bg-2" />
            <div className="my-6 flex flex-row gap-2">
              <div className="h-[36px] w-[50px] animate-pulse rounded-full bg-bg-2" />
              <div className="h-[36px] w-[110px] animate-pulse rounded-full bg-bg-2" />
              <div className="h-[36px] w-[65px] animate-pulse rounded-full bg-bg-2" />
              <div className="h-[36px] w-[88px] animate-pulse rounded-full bg-bg-2" />
            </div>
            <div className="flex flex-col gap-4">
              <ChannelPreviewSkeleton />
              <ChannelPreviewSkeleton />
              <ChannelPreviewSkeleton />
            </div>
          </div>
        </div>
      </div>
      <div className="order-3 flex h-screen w-full flex-col">
        <div className="flex-grow-1 relative flex h-full w-full flex-col">
          <div className="flex h-full w-full flex-col">
            <div className="flex h-[90px] w-full flex-row items-center border-b border-bg-3 px-7">
              <div className="pr-4">
                <MessagesAvatar src="" alt="" rounded size="medium" />
              </div>
              <div>
                <div className="h-[17px] w-[120px] animate-pulse bg-bg-2" />
                <div className="mt-2 h-[17px] w-[100px] animate-pulse bg-bg-2" />
              </div>
            </div>
            <div className="relative flex flex-1 flex-col px-7">
              <div className="mt-[36px] flex w-full flex-row justify-center">
                <div className="h-[18px] w-[80px] animate-pulse bg-bg-2" />
              </div>
              <div className="mt-[36px] flex w-full flex-row items-center">
                <Avatar size="sm" />
                <div className="ml-3 h-[36px] w-[90px] animate-pulse rounded-full bg-bg-2" />
              </div>
              <div className="mt-[44px] flex w-full flex-row justify-center">
                <div className="h-[18px] w-[140px] animate-pulse bg-bg-2" />
              </div>
              <div className="mt-[32px] flex w-full flex-row items-center justify-end">
                <div className="h-[36px] w-[110px] animate-pulse rounded-full bg-bg-2" />
              </div>
            </div>
            <div className="flex h-[70px] w-full flex-row flex-nowrap items-center gap-2 px-7">
              <div className="size-[30px] animate-pulse rounded-[2px] bg-bg-2" />
              <div className="mx-4 flex h-[40px] flex-1 animate-pulse rounded-full bg-bg-2" />
              <div className="size-[30px] animate-pulse rounded-[2px] bg-bg-2" />
              <div className="size-[30px] animate-pulse rounded-[2px] bg-bg-2" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
